import axios from 'axios';

// In production, default to a same-origin '/api' (erpapi serves the site too),
// so the app works regardless of build-time env. Dev falls back to the local API.
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL
    || (process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:5100/api'),
  timeout: 20000,
});

// Attach the JWT on every request.
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('erp_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// On 401 the token is gone or expired. Clearing storage is not enough on its
// own: the app is already rendered and would sit there failing request after
// request until someone reloaded. The event tells AuthContext to drop the user,
// which sends every guarded route to the login screen at once.
export const SESSION_EXPIRED = 'erp:session-expired';

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const url = String(err.config?.url || '');
    // A failed login is a wrong password, not an expired session.
    if (err.response?.status === 401 && !url.includes('/auth/login')) {
      const hadSession = Boolean(localStorage.getItem('erp_token'));
      localStorage.removeItem('erp_token');
      localStorage.removeItem('erp_user');
      if (hadSession) window.dispatchEvent(new CustomEvent(SESSION_EXPIRED));
    }
    return Promise.reject(err);
  }
);

// Uploaded files are served at <host>/uploads/… (outside the /api path).
const FILE_HOST = (api.defaults.baseURL || '').replace(/\/api\/?$/, '');
export const fileSrc = (u) => (u ? (u.startsWith('http') ? u : `${FILE_HOST}${u}`) : null);

export default api;
